import { combineReducers } from 'redux';

//Reducer
import ingresarReducer from './ingresar';
import validarReducer from './validar';
import desafiosReducer from './desafios';
import remokeTokenReducer from './revokeToken';
import generarDesafioCPReducer from './generarDesafioCP';
import validarDesafioCPReducer from './validarDesafioCP';
import generarDesafioTcooReducer from './generarDesafioTcoo';
import validarDesafioTcooReducer from './validarDesafioTcoo';
import timerReducer from './timer';
import informarReducer from './informar';
import transaccionReducer from './transaccion';
import sesionReducer from './sesion';
import loaders from './ui_loaders';
import errorGeneral from './ui_errorGenerico';

const reducers = {
   // domains
  entities: combineReducers ({
    ingresarReducer,
    validarReducer,
    desafiosReducer,
    transaccionReducer,
    remokeTokenReducer,
    generarDesafioCPReducer,
    validarDesafioCPReducer,
    generarDesafioTcooReducer,
    validarDesafioTcooReducer,
    informarReducer,
    sesionReducer,
    timerReducer
  }),
  ui: combineReducers({
    loaders,
    errorGeneral
  }),
};

export default reducers;
